export const ROUTES = {
    LOGIN_ROUTE: '/login',
    REGISTER_ROUTE: '/register',
    REQUEST_RESET_PASSWORD_ROUTE: '/request-reset-pass',
    HOMEPAGE_ROUTE: '/',
    PUBLIC_HOMEPAGE_ROUTE: '/',
    LAST_HOUR_CHART_ROUTE: '/last-hour',
}
